import { render, staticRenderFns } from "./quotation_share_dialog.vue?vue&type=template&id=04456bb9&scoped=true&"
import script from "./quotation_share_dialog.vue?vue&type=script&lang=js&"
export * from "./quotation_share_dialog.vue?vue&type=script&lang=js&"
import style0 from "./quotation_share_dialog.vue?vue&type=style&index=0&id=04456bb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04456bb9",
  null
  
)

export default component.exports